import { IMG, bookingLinkSrc } from '../../const';
import expertPng from '../../assets/images/Andriy-Tatchyn-desktop.png';
import expertWebp from '../../assets/images/Andriy-Tatchyn-desktop.webp';
import expertAvif from '../../assets/images/Andriy-Tatchyn-desktop.avif';
import './expert.scss';

const Expert = () => (
  <div className="expert__block">
    <div>
      <picture>
        <source
          media="(max-width: 428px)"
          srcSet={`${IMG.SOFTWARE_PROJECT_ESTIMATION}/Andriy-Tatchyn.avif`}
          type="image/avif"
        />
        <source
          media="(max-width: 428px)"
          srcSet={`${IMG.SOFTWARE_PROJECT_ESTIMATION}/Andriy-Tatchyn.webp`}
          type="image/webp"
        />
        <source
          media="(max-width: 428px)"
          srcSet={`${IMG.SOFTWARE_PROJECT_ESTIMATION}/Andriy-Tatchyn.jpg`}
        />

        <source
          media="(min-width: 429px)"
          srcSet={expertAvif}
          type="image/avif"
        />
        <source
          media="(min-width: 429px)"
          srcSet={expertWebp}
          type="image/webp"
        />
        <source
          media="(min-width: 429px)"
          srcSet={expertPng}
          type="image/png"
        />

        <img
          src={expertPng}
          alt="Andriy Tatchyn, Chief Commercial Officer"
          width="382"
          height="518"
          loading="lazy"
        />
      </picture>
    </div>
    <div>
      <h3>Andriy Tatchyn</h3>
      <span>Chief Commercial Officer</span>
      <p>
        <span className="quotes" />
        For the past decade, we've tested and refined various estimation
        methodologies. This experience has culminated in a proven set of methods
        and tools that enable us to deliver rapid and accurate software project
        estimations and budgets.
      </p>
      <a
        className="primaryFatLink ic-arrow-up"
        href={bookingLinkSrc}
        target="_blank"
        rel="noopener noreferrer"
      >
        Book a free consultation
      </a>
    </div>
  </div>
);

export default Expert;
